import { Chip, type ChipProps } from '@mui/material';

export interface EventVisibilitySource {
    isInviteOnly?: boolean;
    isEventPublic?: boolean;
}

interface EventVisibilityTagProps extends EventVisibilitySource {
    sx?: ChipProps['sx'];
}

export function getEventVisibilityLabel({ isInviteOnly = false, isEventPublic = true }: EventVisibilitySource): string | null {
    if (isInviteOnly) {
        return 'Invite Only';
    }

    if (isEventPublic === false) {
        return 'Private';
    }

    return null;
}

export function hasEventVisibilityTag(source: EventVisibilitySource): boolean {
    return getEventVisibilityLabel(source) !== null;
}

export function getEventVisibilityChipColor({ isInviteOnly = false }: EventVisibilitySource): ChipProps['color'] {
    return isInviteOnly ? 'warning' : 'secondary';
}

export function EventVisibilityTag({ isInviteOnly = false, isEventPublic = true, sx }: EventVisibilityTagProps) {
    const label = getEventVisibilityLabel({ isInviteOnly, isEventPublic });

    if (!label) {
        return null;
    }

    return (
        <Chip
            label={label}
            size="small"
            color={getEventVisibilityChipColor({ isInviteOnly, isEventPublic })}
            sx={{
                height: 22,
                fontSize: '0.72rem',
                fontWeight: 600,
                ...sx,
            }}
        />
    );
}
